import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userReducer";
import themeSlice from "./themeReducer";
import bizzAppSlice from "./bizzAppReducer";
import channelSlice from "./channelReducer";

const store = configureStore({
  reducer: {
    userData: userSlice,
    theme: themeSlice,
    bizzApps: bizzAppSlice,
    channel: channelSlice,
  },
});

export default store;
